import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Root from './Root';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';

if(process.env.NODE_ENV !== 'development') {
  const sentryDSN = process.env.REACT_APP_SENTRY_DSN;
  Sentry.init({dsn: sentryDSN});
}

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
